// akhila 11/08/2022 2701350359 adding report notes
// akhila  11/10/2022 2701350359 added createdby column and removed add icon
// akhila 11/11/2022 2701350359 bugFix sorting in table
// Sohel 11/14/2022 2700363416 implemented System notes functionality
// Sohel 11/19/2022 2700363416 added userDefined notes popup
// Guru Prasad 11/24/2022 2700363416 fixed popup table alignments
// Akhila 12/09/2022 2700363416 Added form Notes
// Ashraf 12/09/2022 2700363416 fixed notes reset issue
// Dilip 12/12/2022 2700363416 changed tooltip
// Akhila 12/15/2022 2700363416 Added Role based access
// Ashraf 12/19/2022 2700363416 fixed notes search page break
// kavyareddy 12/20/2022 2700363416 Added dropdown for createdBy and noteType
// Raghu 12/26/2022 2700363416 Remove Dialog Component
// Raghu 12/28/2022 2700363416 Table Footer Stylings
// Raghu 02/28/2023 2700363416 addded new class for buttons
// Akhila 06/07/2023 2700363416 added breadcrum code and description
// Dilip-pds 10/19/2023 2700363416 fixed created by dropdown issue
// Gireesh 15-12-2023 2700363416 updated payload
import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Button, Grid} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {
  systempostNotesInformation,
  resetPostStatus,
  systemNotesResetToast,
} from '../../../../redux/reducers/EventTactics/AddNote';
import AddUserDefinedNotes from '../../../../components/AddUserDefinedNotes';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import DialogBox from './../../../../components/DialogBox/index';
import SearchNotesForm from '../../../../components/SearchNotes/searchNotesForm';

const ReportNote = ({
  open,
  dialogClose,
  title,
  maxWidth,
  value,
  handleSubmit,
  condition,
  buttonCondition,
  triggerData,
}) => {
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const {systemnotesStatus, systemisLoading} = useSelector(({addNoteEvent}) => addNoteEvent);
  useEffect(() => {
    if (systemnotesStatus === 200) {
      tableRef.current.onQueryChange();
      handleDialogClose();
      dispatch(resetPostStatus());
      setTimeout(() => {
        dispatch(systemNotesResetToast());
      }, 2000);
    }
  }, [systemnotesStatus]);

  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);

  const dispatchRecordFormatSystemNotes = (data) => {
    dispatch(
      systempostNotesInformation({
        code: triggerData ? triggerData?.code : '',
        noteText: data,
        reportId: triggerData?.id ? triggerData?.id : 0,
      }),
    );
  };
  let transcription = '';
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        // minWidth: "550px",
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created By',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const roleDataDisable = roleData?.window?.['Triggers Maintenance']?.TM;
  const reportMasterDisableAdd = roleData?.window?.['Event Tactic']?.['ET'];
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  return (
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={systemisLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            reportMasterDisableAdd={reportMasterDisableAdd}
          />
        )}
      </DialogBox>
      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          triggerDataBR={triggerData}
          moduleName={'triggermaintaince'}
        />
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `event/find/all/notes`;
                const bodyObj = {
                  code: triggerData?.code,
                  frameworkId: triggerData?.id ? triggerData?.id : 0,
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  search: '',
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!triggerData?.code) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: true,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    <Button
                      variant="outlined"
                      disabled={roleDataDisable.add === false}
                      className="search-btn"
                    >
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                isFreeAction: true,
                disabled: roleDataDisable.add === false,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
};

export default ReportNote;
